import { z } from 'zod'

import { DateZod } from '../common'
import { TeamStatusZod } from '../teams/team-zod'

export const ChannelMessageZod = z.object({
  sender: z.enum(['volunteer', 'admin']),
  senderId: z.string(),
  senderName: z.string(),
  teamId: z.string().optional(),
  teamNumber: z.number().optional(),
  teamStatus: TeamStatusZod.optional(),
  volunteerRole: z.enum(['partner', 'escort', 'driver']).optional(),
  // Pinned to the sys_admin claim by the security rules: a super admin writes as the national office
  // whatever central the thread belongs to, and whatever central their own account belongs to.
  senderSysAdmin: z.boolean().nullish(),
  text: z.string().max(2000).optional(),
  firebaseStoragePath: z.string().optional(),
  imageProperties: z
    .object({
      width: z.number(),
      height: z.number(),
    })
    .optional(),
  createdAt: DateZod,
  deletedAt: DateZod.nullish(),
  deletedBy: z.string().nullish(),
  // Written by the moderator and pinned to their own claim by the security rules, because the
  // central is not persisted on the account — it is minted into the token at sign-in. The trigger
  // resolves it to a name and drops it with the rest of the payload.
  deletedByRegionId: z.string().nullish(),
  // Same arrangement for the sys_admin claim, so a super admin's deletion reads as the national
  // office like their messages do.
  deletedBySysAdmin: z.boolean().nullish(),
})

export type ChannelMessage = z.infer<typeof ChannelMessageZod>
